// removed by extract-text-webpack-plugin
module.exports = {"data_period":"data_period__2lboK"};


//////////////////
// WEBPACK FOOTER
// ./routes/history-records/style.scss
// module id = 7D7g
// module chunks = 6